// Was in der Navigation auftaucht — an EINER Stelle, weil es zwei Navigationen gibt:
// die Leiste oben (FloatingHeader) und die Kacheln auf der Startseite (BentoNavHub).
// Standen die Listen getrennt, fiel beim Abschalten unweigerlich eine durchs Raster
// und die Kachel fuehrte weiter auf eine Seite, die niemand mehr sehen sollte.
//
// `aktiv: false` blendet den Eintrag ueberall aus. Die ROUTE bleibt bestehen — wer den
// Link hat, kommt weiterhin hin, und Wiedereinschalten ist genau ein Wort.

export const NAV_EINTRAEGE = [
  { id: 'shop', aktiv: true, path: '/shop', label: { de: 'Werkzeuge', en: 'Tools' },
    unterzeile: { de: 'Extensions für After Effects', en: 'Extensions for After Effects' } },
  { id: 'all-in-one', aktiv: true, path: '/shop/all-in-one', label: { de: 'All-in-One', en: 'All-in-One' },
    unterzeile: { de: 'Alle Werkzeuge im Abo', en: 'Every tool, one subscription' } },
  // Kostenlos liegt englisch auf /free
  { id: 'kostenlos', aktiv: true, path: '/kostenlos', pathEn: '/free', label: { de: 'Kostenlos', en: 'Free' },
    unterzeile: { de: 'Gratis-Presets und Footage', en: 'Free presets and footage' } },
  { id: 'installer', aktiv: true, path: '/installer', label: { de: 'Installer', en: 'Installer' },
    unterzeile: { de: 'Gratis laden', en: 'Free download' } },
  { id: 'support', aktiv: true, path: '/support', label: { de: 'Support', en: 'Support' },
    unterzeile: { de: 'Hilfe und FAQ', en: 'Help and FAQ' } },
  { id: 'studio', aktiv: false, path: '/builder', label: { de: 'Studio', en: 'Studio' },
    unterzeile: { de: '3D-Text gestalten', en: 'Design 3D text' } },
  { id: 'arcade', aktiv: false, path: '/games', label: { de: 'Arcade', en: 'Arcade' },
    unterzeile: { de: 'Mini-Games spielen', en: 'Play mini-games' } },
];

// Die sichtbaren Eintraege, fertig fuer die jeweilige Sprache.
export function navEintraege(isEnglish) {
  const sp = isEnglish ? 'en' : 'de';
  return NAV_EINTRAEGE.filter(e => e.aktiv).map(e => ({
    id: e.id,
    label: e.label[sp],
    subtitle: e.unterzeile ? e.unterzeile[sp] : '',
    path: (isEnglish && e.pathEn) ? e.pathEn : e.path,
  }));
}
